/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { PagesGestioneUtenteApprovaUtenteComponent } from './approva-utente/approva-utente.component';
import { PagesGestioneUtenteAttesaProfiloComponent } from './attesa-profilo/attesa-profilo.component';
import { PagesGestioneUtenteRoutingModule } from './gestione-utente.routing';
import { PagesGestioneUtenteProfiloComponent } from './profilo/profilo.component';
import { PagesGestioneUtenteRicercaUtenteComponent } from './ricerca-utente/ricerca-utente.component';
import { PagesGestioneUtenteRichiestaProfiloComponent } from './richiesta-profilo/richiesta-profilo.component';
import { PagesGestioneUtenteToolkitModule } from './_toolkit/toolkit.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        NgbModule,
        PagesGestioneUtenteRoutingModule,
        PagesGestioneUtenteToolkitModule,
    ],
    declarations: [
        PagesGestioneUtenteApprovaUtenteComponent,
        PagesGestioneUtenteAttesaProfiloComponent,
        PagesGestioneUtenteProfiloComponent,
        PagesGestioneUtenteRicercaUtenteComponent,
        PagesGestioneUtenteRichiestaProfiloComponent,
    ],
    exports: [
        PagesGestioneUtenteApprovaUtenteComponent,
        PagesGestioneUtenteAttesaProfiloComponent,
        PagesGestioneUtenteProfiloComponent,
        PagesGestioneUtenteRicercaUtenteComponent,
        PagesGestioneUtenteRichiestaProfiloComponent,
    ],
})
export class PagesGestioneUtenteModule { }
